import React from "react";
import { Box, Link, Stack, Typography } from "@mui/material";
import {
  getAccent,
  getColorWithMode,
  getMutedText,
  HEADING_FONT,
} from "../../constants/colors";

// Shared modern page header for the gear explore pages: soft radial accent
// glow, uppercase eyebrow, Inter title and muted subtitle.
const GearPageHeader = ({
  darkMode,
  eyebrow = "Gear",
  title,
  subtitle,
  showSubmitLink = false,
}) => (
  <Box
    sx={{
      width: "100%",
      background: darkMode
        ? "radial-gradient(ellipse 90% 120% at 50% -20%, rgba(25,118,210,0.22), transparent)"
        : "radial-gradient(ellipse 90% 120% at 50% -20%, rgba(25,118,210,0.09), transparent)",
    }}
  >
    <Stack
      textAlign="center"
      alignItems="center"
      gap="8px"
      sx={{ padding: "32px 16px 26px 16px" }}
    >
      {eyebrow && (
        <Typography
          sx={{
            fontFamily: HEADING_FONT,
            fontWeight: 700,
            fontSize: "12px",
            letterSpacing: "0.14em",
            textTransform: "uppercase",
            color: getAccent(darkMode),
          }}
        >
          {eyebrow}
        </Typography>
      )}
      <Typography
        variant="h4"
        component="h1"
        sx={{
          fontWeight: 800,
          fontFamily: HEADING_FONT,
          letterSpacing: "-0.02em",
          color: getColorWithMode(darkMode, "text"),
        }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="body1"
          sx={{
            fontFamily: HEADING_FONT,
            color: getMutedText(darkMode),
            maxWidth: "700px",
          }}
        >
          {subtitle}
        </Typography>
      )}
      {showSubmitLink && (
        <Link
          href="/gear/submit"
          underline="hover"
          sx={{
            marginTop: "4px",
            fontFamily: HEADING_FONT,
            fontWeight: 600,
            fontSize: "14px",
            color: getAccent(darkMode),
          }}
        >
          Don't see a piece of gear? Submit gear
        </Link>
      )}
    </Stack>
  </Box>
);

export default GearPageHeader;
